import { BASE_URL } from 'config';
import { useEffect, useState } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Card from "@mui/material/Card";
import TextField from "@mui/material/TextField";
import CircularProgress from "@mui/material/CircularProgress";
import Avatar from "@mui/material/Avatar";
import PersonIcon from "@mui/icons-material/Person";
import { useMaterialUIController, setDirection } from "context";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import CardContent from "@mui/material/CardContent";
import Link from "@mui/material/Link";
import EditIcon from "@mui/icons-material/Edit";
import Button from "@mui/material/Button";
import PersonalInfoEdit from "./personalInfoEdit";
import StoreInfoEdit from "./storeInfoEdit";
import StoreDocumentsEdit from "./storeDocumentsEdit";

function StoreProfile() {
  const [controller, dispatch] = useMaterialUIController();
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  // حالة فتح/إغلاق Dialog تعديل البيانات الشخصية
  const [personalDialogOpen, setPersonalDialogOpen] = useState(false);
  // حالة فتح/إغلاق Dialog تعديل بيانات المتجر
  const [storeDialogOpen, setStoreDialogOpen] = useState(false);
  // حالة فتح/إغلاق Dialog تعديل وثائق المتجر
  const [documentsDialogOpen, setDocumentsDialogOpen] = useState(false);

  useEffect(() => {
    setDirection(dispatch, "rtl");
    fetchProfile();
    return () => setDirection(dispatch, "ltr");
    // eslint-disable-next-line
  }, []);

  const fetchProfile = async () => {
    setLoading(true);
    const token = localStorage.getItem("user-token");
    try {
      const response = await fetch(BASE_URL + "/manager/profile", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await response.json();
      setProfile(data.data);
    } catch (error) {
      setProfile(null);
    } finally {
      setLoading(false);
    }
  };

  // Helper function to render value or 'لا يوجد' in red
  const renderValue = (value) =>
    value && value !== "null" && value !== null && value !== undefined && value !== "" ? (
      value
    ) : (
      <span style={{ color: "#d32f2f", fontWeight: "bold" }}>لا يوجد</span>
    );

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Card sx={{ width: "100%", p: 4, boxShadow: 3, textAlign: "left" }}>
          <MDTypography
            variant="h5"
            fontWeight="bold"
            mb={3}
            color="primary"
            sx={{ textAlign: "left" }}
          >
            الملف الشخصي للمتجر
          </MDTypography>
          {loading ? (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight={300} py={6}>
              <CircularProgress size={60} sx={{ color: "#ca9937" }} />
            </Box>
          ) : profile ? (
            <MDBox
              display="flex"
              flexDirection="column"
              gap={3}
              sx={{ maxWidth: 800, width: "100%" }}
            >
              {/* البيانات الشخصية */}
              <Grid container spacing={3}>
                <Grid item xs={12} md={4}>
                  <Avatar
                    src={
                      profile.avatar
                        ? `https://back.al-balad.sa/uploads/users/avatars/${profile.avatar}`
                        : undefined
                    }
                    sx={{
                      width: 90,
                      height: 90,
                      bgcolor: "grey.200",
                      mb: 1,
                      alignSelf: "flex-start",
                    }}
                  >
                    {!profile.avatar && <PersonIcon sx={{ fontSize: 48, color: "#bdbdbd" }} />}
                  </Avatar>
                </Grid>
                <Grid item xs={12} md={8}>
                  <TextField
                    label="الرقم التعريفي"
                    value={profile.id || "-"}
                    InputProps={{ readOnly: true }}
                    fullWidth
                    variant="outlined"
                    sx={{ mb: 2 }}
                  />
                  <TextField
                    label="اسم المستخدم"
                    value={profile.name || "-"}
                    InputProps={{ readOnly: true }}
                    fullWidth
                    variant="outlined"
                    sx={{ mb: 2 }}
                  />
                  <TextField
                    label="البريد الإلكتروني"
                    value={profile.email || "-"}
                    InputProps={{ readOnly: true }}
                    fullWidth
                    variant="outlined"
                    sx={{ mb: 2 }}
                  />
                  <TextField
                    label="رقم الهاتف"
                    value={profile.phone || "-"}
                    InputProps={{ readOnly: true }}
                    fullWidth
                    variant="outlined"
                  />
                </Grid>
                {/* زر تعديل البيانات الشخصية */}
                <Grid item xs={12} mt={2} display="flex" justifyContent="flex-end">
                  <Button
                    variant="contained"
                    color="primary"
                    startIcon={<EditIcon />}
                    sx={{ borderRadius: 2, fontWeight: "bold", px: 4, color: "white !important" }}
                    onClick={() => setPersonalDialogOpen(true)}
                  >
                    تعديل البيانات الشخصية
                  </Button>
                </Grid>
              </Grid>

              {/* بيانات المتجر */}
              {profile.store && (
                <Card sx={{ mt: 4, boxShadow: 2 }}>
                  <CardContent>
                    <MDTypography variant="h6" fontWeight="bold" mb={2} color="primary">
                      بيانات المتجر
                    </MDTypography>
                    <Grid container spacing={3}>
                      <Grid item xs={12} md={3}>
                        <Avatar
                          src={profile.store.logo ? profile.store.logo : undefined}
                          sx={{
                            width: 110,
                            height: 110,
                            bgcolor: "grey.200",
                            mb: 1,
                            borderRadius: 2,
                          }}
                        />
                        <MDTypography variant="subtitle1" fontWeight="bold" mt={1}>
                          {profile.store.name_ar}
                        </MDTypography>
                        <MDTypography variant="caption" color="text.secondary">
                          {profile.store.name_en}
                        </MDTypography>
                      </Grid>
                      <Grid item xs={12} md={9}>
                        <Grid container spacing={2}>
                          <Grid item xs={12} md={6}>
                            <MDTypography variant="body2" fontWeight="bold">
                              البريد الإلكتروني:
                            </MDTypography>
                            <MDTypography variant="body2" color="text.secondary">
                              {renderValue(profile.store.email)}
                            </MDTypography>
                          </Grid>
                          <Grid item xs={12} md={6}>
                            <MDTypography variant="body2" fontWeight="bold">
                              رقم الجوال:
                            </MDTypography>
                            <MDTypography variant="body2" color="text.secondary">
                              {renderValue(profile.store.phone)}
                            </MDTypography>
                          </Grid>
                          <Grid item xs={12} md={6}>
                            <MDTypography variant="body2" fontWeight="bold">
                              العنوان:
                            </MDTypography>
                            <MDTypography variant="body2" color="text.secondary">
                              {renderValue(profile.store.street)}
                            </MDTypography>
                          </Grid>
                          <Grid item xs={12} md={6}>
                            <MDTypography variant="body2" fontWeight="bold">
                              الرمز البريدي:
                            </MDTypography>
                            <MDTypography variant="body2" color="text.secondary">
                              {renderValue(profile.store.zip_code)}
                            </MDTypography>
                          </Grid>
                          <Grid item xs={12} md={6}>
                            <MDTypography variant="body2" fontWeight="bold">
                              الموقع الجغرافي:
                            </MDTypography>
                            <Box
                              sx={{
                                mt: 1,
                                borderRadius: 2,
                                overflow: "hidden",
                                boxShadow: 1,
                                width: "100%",
                              }}
                            >
                              {profile.store.location ? (
                                <div
                                  style={{ width: "100%" }}
                                  dangerouslySetInnerHTML={{
                                    __html: profile.store.location
                                      .replace('width="600"', 'width="100%"')
                                      .replace('height="450"', 'height="350"')
                                      .replace(
                                        'style="border:0;"',
                                        'style="border:0;width:100%;height:350px;"'
                                      ),
                                  }}
                                />
                              ) : (
                                <MDTypography color="text.secondary">
                                  لا يوجد موقع جغرافي
                                </MDTypography>
                              )}
                            </Box>
                          </Grid>
                          <Grid item xs={12} md={12}>
                            <MDTypography variant="body2" fontWeight="bold" sx={{ mb: 1 }}>
                              التسلسل الجغرافي:
                            </MDTypography>
                            <MDTypography variant="body2" color="text.secondary">
                              {renderValue(profile.store.location_hierarchy?.country?.name)} -{" "}
                              {renderValue(profile.store.location_hierarchy?.state?.name)} -{" "}
                              {renderValue(profile.store.location_hierarchy?.province?.name)}
                            </MDTypography>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                    {/* زر تعديل بيانات المتجر */}
                    <Box display="flex" justifyContent="flex-end" mt={3}>
                      <Button
                        variant="contained"
                        color="primary"
                        startIcon={<EditIcon />}
                        sx={{
                          borderRadius: 2,
                          fontWeight: "bold",
                          px: 4,
                          color: "white !important",
                        }}
                        onClick={() => setStoreDialogOpen(true)}
                      >
                        تعديل بيانات المتجر
                      </Button>
                    </Box>
                  </CardContent>
                </Card>
              )}

              {/* وثائق المتجر */}
              {profile.store?.documents && (
                <Card sx={{ mt: 4, boxShadow: 2 }}>
                  <CardContent>
                    <MDTypography variant="h6" fontWeight="bold" mb={2} color="primary">
                      وثائق المتجر
                    </MDTypography>
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={6}>
                        <MDTypography variant="body2" fontWeight="bold">
                          اسم النشاط التجاري:
                        </MDTypography>
                        <MDTypography variant="body2" color="text.secondary">
                          {renderValue(profile.store.documents.business_name)}
                        </MDTypography>
                        <MDTypography variant="body2" fontWeight="bold" mt={2}>
                          رقم السجل التجاري:
                        </MDTypography>
                        <MDTypography variant="body2" color="text.secondary">
                          {renderValue(profile.store.documents.commercial_registration_number)}
                        </MDTypography>
                        <MDTypography variant="body2" fontWeight="bold" mt={2}>
                          تاريخ انتهاء السجل:
                        </MDTypography>
                        <MDTypography variant="body2" color="text.secondary">
                          {renderValue(profile.store.documents.cr_expiry_date)}
                        </MDTypography>
                        <MDTypography variant="body2" fontWeight="bold" mt={2}>
                          رقم الرخصة البلدية:
                        </MDTypography>
                        <MDTypography variant="body2" color="text.secondary">
                          {renderValue(profile.store.documents.municipal_license_number)}
                        </MDTypography>
                        <MDTypography variant="body2" fontWeight="bold" mt={2}>
                          تاريخ انتهاء الرخصة:
                        </MDTypography>
                        <MDTypography variant="body2" color="text.secondary">
                          {renderValue(profile.store.documents.municipal_license_expiry)}
                        </MDTypography>
                        <MDTypography variant="body2" fontWeight="bold" mt={2}>
                          الرقم الموحد:
                        </MDTypography>
                        <MDTypography variant="body2" color="text.secondary">
                          {renderValue(profile.store.documents.unified_number)}
                        </MDTypography>
                        <MDTypography variant="body2" fontWeight="bold" mt={2}>
                          رقم الجوال للمالك:
                        </MDTypography>
                        <MDTypography variant="body2" color="text.secondary">
                          {renderValue(profile.store.documents.owner_phone)}
                        </MDTypography>
                        <MDTypography variant="body2" fontWeight="bold" mt={2}>
                          الرقم الضريبي:
                        </MDTypography>
                        <MDTypography variant="body2" color="text.secondary">
                          {renderValue(profile.store.documents.tax_number)}
                        </MDTypography>
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <MDTypography variant="body2" fontWeight="bold">
                          صورة السجل التجاري:
                        </MDTypography>
                        <Box mb={2}>
                          <Link
                            href={profile.store.documents.cr_file_url}
                            target="_blank"
                            rel="noopener"
                          >
                            <img
                              src={profile.store.documents.cr_file_url}
                              alt="سجل تجاري"
                              style={{
                                width: "100%",
                                maxWidth: 200,
                                borderRadius: 8,
                                boxShadow: 1,
                              }}
                            />
                          </Link>
                        </Box>
                        <MDTypography variant="body2" fontWeight="bold">
                          صورة الرخصة البلدية:
                        </MDTypography>
                        <Box mb={2}>
                          <Link
                            href={profile.store.documents.license_file_url}
                            target="_blank"
                            rel="noopener"
                          >
                            <img
                              src={profile.store.documents.license_file_url}
                              alt="رخصة بلدية"
                              style={{
                                width: "100%",
                                maxWidth: 200,
                                borderRadius: 8,
                                boxShadow: 1,
                              }}
                            />
                          </Link>
                        </Box>
                        <MDTypography variant="body2" fontWeight="bold">
                          صورة العنوان الوطني:
                        </MDTypography>
                        <Box mb={2}>
                          <Link
                            href={profile.store.documents.national_address_file_url}
                            target="_blank"
                            rel="noopener"
                          >
                            <img
                              src={profile.store.documents.national_address_file_url}
                              alt="العنوان الوطني"
                              style={{
                                width: "100%",
                                maxWidth: 200,
                                borderRadius: 8,
                                boxShadow: 1,
                              }}
                            />
                          </Link>
                        </Box>
                        <MDTypography variant="body2" fontWeight="bold">
                          صورة الرقم الضريبي:
                        </MDTypography>
                        <Box mb={2}>
                          <Link
                            href={profile.store.documents.tax_file_url}
                            target="_blank"
                            rel="noopener"
                          >
                            <img
                              src={profile.store.documents.tax_file_url}
                              alt="الرقم الضريبي"
                              style={{
                                width: "100%",
                                maxWidth: 200,
                                borderRadius: 8,
                                boxShadow: 1,
                              }}
                            />
                          </Link>
                        </Box>
                      </Grid>
                    </Grid>
                    {/* زر تعديل وثائق المتجر */}
                    <Box display="flex" justifyContent="flex-end" mt={3}>
                      <Button
                        variant="contained"
                        color="primary"
                        startIcon={<EditIcon />}
                        sx={{
                          borderRadius: 2,
                          fontWeight: "bold",
                          px: 4,
                          color: "white !important",
                        }}
                        onClick={() => setDocumentsDialogOpen(true)}
                      >
                        تعديل وثائق المتجر
                      </Button>
                    </Box>
                  </CardContent>
                </Card>
              )}
            </MDBox>
          ) : (
            <MDTypography color="error" align="center">
              تعذر تحميل البيانات
            </MDTypography>
          )}
        </Card>
      </MDBox>
      {/* Dialog تعديل البيانات الشخصية */}
      <PersonalInfoEdit open={personalDialogOpen} onClose={() => setPersonalDialogOpen(false)} />
      {/* Dialog تعديل بيانات المتجر */}
      <StoreInfoEdit open={storeDialogOpen} onClose={() => setStoreDialogOpen(false)} />
      {/* Dialog تعديل وثائق المتجر */}
      <StoreDocumentsEdit
        open={documentsDialogOpen}
        onClose={() => setDocumentsDialogOpen(false)}
      />
    </DashboardLayout>
  );
}

export default StoreProfile;
